import { jsx as _jsx } from "react/jsx-runtime";
import React, { Fragment, useMemo } from 'react';
import { ImageListItem } from '@mui/material';
import { t } from 'i18next';
import { SimpleTable } from '~/views/molecules/simple-table/simple-table';
export const History = ({ items }) => {
    const config = useMemo(() => {
        return {
            headerColumns: [
                {
                    label: t('DIALOG_FILE_INFO_OWNER'),
                    columnWidth: 5,
                },
                {
                    label: t('DIALOG_FILE_INFO_DATE'),
                    columnWidth: 7,
                },
            ],
            rowColumns: [
                {
                    fieldKey: 'name',
                    columnWidth: 5,
                },
                {
                    fieldKey: 'cdate',
                    columnWidth: 7,
                },
            ],
        };
    }, []);
    return (_jsx(Fragment, { children: _jsx(ImageListItem, { className: 'table-view', children: _jsx(SimpleTable, { config: config, data: items }) }) }));
};
